import { createFileRoute } from '@tanstack/react-router'
import React from 'react'
import { useAuth } from '../auth'
import { CompanySettings } from '../settings/components/company-settings'
import { useTitle } from '../hooks/use-title'
import { useTranslation } from 'react-i18next'
import { z } from 'zod'
import { PageTitle } from '../components/page-title'

const UnsubscribedView = React.lazy(() =>
    import('../subscription/components/unsubscribed-view').then((module) => ({ default: module.UnsubscribedView }))
)

const settingsSearchSchema = z.object({
    upgrade: z.boolean().optional().catch(undefined),
})

export const Route = createFileRoute('/_auth/_main/settings')({
    validateSearch: settingsSearchSchema,
    component: Settings,
})

function Settings() {
    const { hasSubscription } = useAuth()
    const { upgrade } = Route.useSearch()
    const { t } = useTranslation()

    useTitle(t('Settings'))

    const title = <PageTitle title={t('Settings')} />

    if (hasSubscription) {
        return (
            <>
                {title}
                <CompanySettings upgrade={upgrade} />
            </>
        )
    }

    return (
        <>
            {title}
            <UnsubscribedView />
        </>
    )
}
